export const tracking = {
    isPending: false,
    error: null,
};
